import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { ApolloClient } from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client/lib/main';
import fontawesome from '@fortawesome/fontawesome';
import throttle from 'lodash/throttle';
import faChevronLeft from '@fortawesome/fontawesome-pro-light/faChevronLeft';
import faChevronRight from '@fortawesome/fontawesome-pro-light/faChevronRight';
import faFilter from '@fortawesome/fontawesome-pro-light/faFilter';
import faSync from '@fortawesome/fontawesome-pro-light/faSync';
import faSpinner from '@fortawesome/fontawesome-pro-light/faSpinner';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import { ThemeProvider } from 'styled-components';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import muiTheme from './theme';
import './index.css';

import { loadState, saveState } from './utils/localStorage';
import rootReducer from './redux';
import Root from './containers/Root';

import { render } from 'react-snapshot';
import ReactGA from 'react-ga4';

const middlewares = [thunk];
const persistedState = loadState();

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,
  persistedState,
  composeEnhancers(applyMiddleware(...middlewares))
);

store.subscribe(
  throttle(() => {
    const { apply } = store.getState();
    saveState({
      auth: store.getState().auth,
      apply: apply.step ? apply : { ...apply, step: 0 },
      parkingAuth: store.getState().parkingAuth
    });
  }, 1000)
);

const httpLink = createUploadLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`
});

// const authLink = setContext((_, { headers }) => {
//   // get the authentication token from local storage if it exists
//   // return the headers to the context so httpLink can read them
//   const localState = JSON.parse(localStorage.state);
//   return {
//     headers: {
//       ...headers,
//       'X-User-Email': localState.auth.email,
//       'X-User-Token': localState.auth.token
//     }
//   };
// });

const client = new ApolloClient({
  // link: authLink.concat(httpLink),
  link: httpLink,
  cache: new InMemoryCache()
});

fontawesome.library.add(
  faChevronLeft,
  faChevronRight,
  faFilter,
  faSync,
  faSpinner
);

const artzuUiTheme = {
  main: '#128DFF',
  lightGrey: '#DEDEDE',
  darkGrey: '#414141'
};

const App = () => {
  ReactGA.initialize('G-GV68TMSEP1');
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);
  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <ThemeProvider theme={artzuUiTheme}>
          <MuiThemeProvider muiTheme={muiTheme}>
            <Root />
          </MuiThemeProvider>
        </ThemeProvider>
      </Provider>
    </ApolloProvider>
  );
};

render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js